import React from "react";
import Challenger from "../../../assets/images/Challenger.svg"; // Fallback image


const ChallengerCard: React.FC = () => {
  return (
    <section className="py-20 bg-[#FFFDF5]">
      <div className="container mx-auto px-4 lg:px-4">
        <div className="flex flex-col lg:flex-row items-center gap-16">

          {/* Left Side - Challenger Card Mockup */}
          <div className="w-full lg:w-5/12 relative flex justify-left">
            {/* Background offset */}
            {/* <div className="absolute inset-0 bg-navYellow/20 rounded-3xl transform -translate-x-6 translate-y-6 max-w-sm mx-auto"></div> */}
            <img
              src={Challenger}
              alt="CBR Program Study"
              className="rounded-2xl h-[320px] md:h-[420px] lg:h-[550px]"
            />

          </div>

          {/* Right Side - Text Content */}
          <div className="w-full lg:w-7/12">
            <p className="text-navYellow font-medium text-xl tracking-wider mb-3">The Challenger CARD<sup>&reg;</sup></p>
            <h2 className="text-3xl lg:text-4xl font-semibold text-darkBlue mb-6">
              Track your growth monthly with the Challenger CARD<sup>&reg;</sup>
            </h2>
            <p className="text-gray-600 text-lg mb-8 leading-relaxed">
              The Challenger CARD<sup>&reg;</sup> is an internal evaluation tool we developed to track your growth throughout the CBR journey. You'll evaluate and score yourself every 4 weeks for the duration of the course
              with the intent to show everyone your progress in some tangible ways. This will motivate you towards excellence (1Tim 4:15).
              <br />The Challenger CARD<sup>&reg;</sup> enables a weekly growth points analysis assessing:
            </p>

            <div className="space-y-6 mb-8">
              {[
                {
                  title: "Perserverance",
                  desc: "Developing discipline by consistently meeting your daily early-rising and Bible-reading targets.",
                  icon: "M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0z"
                },
                {
                  title: "Accountability",
                  desc: "Motivate your group by showing them your progress in reading and applying the Word.",
                  icon: "M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z"
                },
                {
                  title: "Meditation",
                  desc: "Controlling your mind to stay focused and fully engaged with the Word you are reading.",
                  icon: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4"
                },
                {
                  title: "Prayerfulness",
                  desc: "Expecting answers by praying back the insights you gain from your daily CBR devotions.",
                  icon: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                }
              ].map((feature, idx) => (
                <div key={idx} className="flex gap-4">
                  <div className={`mt-1 flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center ${idx % 2 === 0 ? 'bg-blue-100/50 text-blue-500' : 'bg-pink-100/50 text-pink-500'}`}>
                    <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={feature.icon} />
                    </svg>
                  </div>
                  <div>
                    <h4 className="font-semibold text-darkBlue mb-1">{feature.title}</h4>
                    <p className="text-gray-600 text-base">{feature.desc}</p>
                  </div>
                </div>
              ))}
            </div>



          </div>
        </div>
        <div className="bg-white border border-gray-100 rounded-xl p-4 shadow-sm flex items-start gap-4 text-sm mt-8 relative">

          <div>
            <span className="font-semibold text-darkBlue">How it works:</span>
            <p className="text-gray-700 text-base mt-1">These qualities are weighted and aggregated into a 10-point weekly growth scale.
              You will assess yourself weekly to make discipline formation tangible and measurable.</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ChallengerCard;
